// extracted by mini-css-extract-plugin
module.exports = {"edit-link":"edit-link_edit-link__1IwXg","edit-link--selected":"edit-link_edit-link--selected__QdeCG"};